module.exports = __webpack_public_path__ + "static/media/029-comoros.d1dd7522.svg";